import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { eChannels, eTopics, ePublishers } from '../../../utils/enums';
import { publishTopicOnChannel } from '../../../services/external-pub-sub/pub-sub-utils';

class TestPageCTA extends React.Component {


  render() {
    const { isLoggedIn } = this.props.userContext;
    const { session, payments, crm, crosssell, player } = eChannels;
    const {
      session: { heartBeat, inactivityTimeout },
      payments: { CTA_Cashier_Open },
      crm: { CTA_RICH_Open, CTA_ExternalLink_Open },
      crosssell: { CTA_CasinoClient_Open, CTA_LiveDealer_Open, CTA_Vegas_Open, CTA_PokerClient_Open },
      player: { CTA_NRS_Open, CTA_Login_Request_Submit, CTA_MyAccount_Open },
      }
     = eTopics;

    return (
      <div className="sport-client-test-page-container">
        <h3 className="test-page-title">Test page for pub-sub mechanism.</h3>

        <h4 className="test-page-subtitle">Cross Sale actions</h4>
        <div className="buttons-area">
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_CasinoClient_Open, crosssell, 'Cross Sale TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open Casino</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_LiveDealer_Open, crosssell, 'Cross Sale TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open Live Dealer</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_Vegas_Open, crosssell, 'Cross Sale TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open Vegas</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_PokerClient_Open, crosssell, 'Cross Sale TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open Poker</p>

        </div>

        <h4 className="test-page-subtitle">Open Service actions</h4>
        <div className="buttons-area">
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_NRS_Open, player, 'Open Service TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open NRS</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_Login_Request_Submit, player, 'Open Service TEST PAGE', null, { publisher: ePublishers.sportclient })}>Open Login</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_ExternalLink_Open, crm, 'Open Service TEST PAGE', { Url: 'https://www.gibraltar.gov.gi' }, { publisher: ePublishers.sportclient })}>Open External Url</p>
        </div>
        { isLoggedIn &&
        <div className="buttons-area">
          <label>Log In required:</label>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_Cashier_Open, payments, 'Log In required TEST PAGE', { 'TabId': 16 }, { publisher: ePublishers.sportclient })}> Open Cashier on Quick Deposit - TabId=16 & NO PromoCode</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_Cashier_Open, payments, 'Log In required TEST PAGE', { 'TabId': 16, PromoCode: 'SUNFUN' }, { publisher: ePublishers.sportclient })}> Open Cashier on Quick Deposit - TabId=16 & PromoCode</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_Cashier_Open, payments, 'Log In required TEST PAGE', { 'PromoCode': 'sunfun' }, { publisher: ePublishers.sportclient })}> Open Cashier - PromoCode & NO TabId</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_MyAccount_Open, player, 'Log In required TEST PAGE', null, { publisher: ePublishers.sportclient })}> Open MyAccount</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_MyAccount_Open, player, 'Log In required TEST PAGE', { 'TabId':16 }, { publisher: ePublishers.sportclient })}> Open my challenges page</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(CTA_RICH_Open, crm, 'Log In required TEST PAGE', { 'CampaignId':104 }, { publisher: ePublishers.sportclient })}> Open Rich</p>
        </div>
        }

        <h4 className="test-page-subtitle">Publish actions as the Rapper( Wrapper)</h4>
        <div className="buttons-area">
          <p className="test-button" onClick={() => publishTopicOnChannel(heartBeat, session, 'CTA TEST PAGE', null, { publisher: ePublishers.sportwrapper })}> Heartbeat</p>
        </div>

        <h4 className="test-page-subtitle">Publish actions as SportClient</h4>
        <div className="buttons-area">
          <p className="test-button" onClick={() => publishTopicOnChannel(heartBeat, session, 'CTA TEST PAGE', null, { publisher: ePublishers.sportclient })}> Hearbeat</p>
          <p className="test-button" onClick={() => publishTopicOnChannel(inactivityTimeout, session, 'CTA TEST PAGE sendKickToWrapper()', null, { publisher: ePublishers.sportclient })}> Kickout</p>
        </div>

        <h4 className="test-page-subtitle">CTAs - Inside components(B2C) to SportClient</h4>
        <div className="buttons-area">
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenCashier(16,'promocodehere')}> Open Cashier</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenMyAccount(16)}> Open My Account</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenCasino()}> Open Casino</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenExternalLink('https://www.gibraltar.gov.gi')}> Open External Link</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenPoker()}> Open Poker</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenRegistration()}> Open Registration</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenClientDeeplink('/filter/all/all/all/all/starting-soon')}> Open Client Deeplink</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenLiveDealer()}> OpenLiveDealer</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenVegas()}> Open Vegas</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.OpenRich(123)}> Open Rich</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.Login()}> Login</p>
          <p className="test-button" onClick={() => window.SportClient.CTA.Logout()}> Logout</p>

        </div>
        {
          window.callParentPostMessage &&
          <div className="buttons-area">
            <label>Needs window.callParentPostMessage defined:</label>
              <p className="test-button" onClick={() => window.callParentPostMessage({ ActionId: '32',Url: '/football/football-betting.htm#/filter/football' })}>*Internal URL*</p>
              <p className="test-button" onClick={() => window.callParentPostMessage({ ActionId: '56' })}>Open loyalty page</p>
          </div>

        }

        </div>
    );
  }
}

TestPageCTA.propTypes = {
  userContext: PropTypes.object
};

function mapStateToProps(state) {
  const { userContext } = state;
  return { userContext };
}

export default connect(mapStateToProps)(TestPageCTA);
